import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { DashboardService, DashboardStats } from '../../services/dashboard.service';
import { AnalyticsService } from '../../services/analytics.service';
import { Observable } from 'rxjs';
import { User } from '@angular/fire/auth';
import { MaterialModule } from '../../shared/material.module';
import { BreadcrumbComponent } from 'src/app/components/shared/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, HttpClientModule, RouterModule, MaterialModule, BreadcrumbComponent],
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  user$!: Observable<User | null>;
  dashboardStats: DashboardStats = {
    totalCards: 0,
    activeCards: 0,
    totalBookmarks: 0,
    cardMetrics: {
      totalViews: 0,
      clicks: 0,
      saves: 0 
    }
  };
  globalAnalytics: { views: number; clicks: number; saves: number; bookmarks: number } | null = null;
  isLoadingStats = true;
  statsError: string | null = null;

  constructor(
    public authService: AuthService,
    private dashboardService: DashboardService,
    private analyticsService: AnalyticsService
  ) {
    this.user$ = this.authService.user$;
  }

  ngOnInit(): void {
    console.log('🎯 Dashboard component initialized');
    this.loadDashboardStats();
    this.loadGlobalAnalytics();
  }

  loadDashboardStats(): void {
    this.isLoadingStats = true;
    this.statsError = null;

    this.authService.user$.subscribe(user => {
      if (!user?.uid) {
        this.statsError = 'User not found';
        this.isLoadingStats = false;
        return;
      }

      const userId = user.uid;
      console.log('📊 Loading dashboard stats using optimized CardsService state...');

      // Use the new optimized getDashboardStats method
      this.dashboardService.getDashboardStats(userId).subscribe({
        next: (stats) => {
          console.log('✅ Dashboard stats loaded successfully:', stats);
          this.dashboardStats = stats;
          this.isLoadingStats = false;
        },
        error: (error) => {
          console.error('❌ Error loading dashboard stats:', error);
          this.statsError = 'Failed to load dashboard statistics';
          this.isLoadingStats = false;
        }
      });
    });
  }

  async onSignOut(): Promise<void> {
    try {
      await this.authService.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }

  loadGlobalAnalytics(): void {
    this.analyticsService.getCardsEventSummary()
      .then((data) => {
        this.globalAnalytics = data;
      })
      .catch((err) => {
        console.error('Failed to load global analytics summary', err);
        this.globalAnalytics = null;
      });
  }
}
